module.exports = __webpack_public_path__ + "static/img/3.f3c886d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/eng/3.png
// module id = 361O
// module chunks = 0